import gql from 'graphql-tag';

export default gql`
  fragment communityInfo on Community {
    id
    createdAt
    name
    slug
    description
    website
    profilePhoto
    coverPhoto
    pinnedThreadId
    isPrivate
    watercoolerId
    lastActive
    redirect
    noindex
    introduction
    rules
    tag
    communityPermissions {
      isMember
      isBlocked
      isOwner
      isPending
      isModerator
      reputation
      lastSeen
      isExpert
      isChair
    }
    brandedLogin {
      isEnabled
      message
    }
  }
`;
